import {
  Button,
  ClickAwayListener,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
} from '@material-ui/core/'
import { Person } from '@material-ui/icons'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import { useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { logout } from '../../actions/userActions'
import {
  LOGIN_TAB_OPEN,
  SIGNUP_TAB_OPEN,
} from '../../constants/navigationConstants'
import useWindowSize from '../../hooks/useWindowSize'

const NavMenu = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()
  const size = useWindowSize()

  const isHomePage = location.pathname === '/'

  const [open, setOpen] = useState(false)
  const anchorRef = useRef(null)

  const { userInfo } = useSelector((state) => state.userLogin)

  const showCreateAQuoteButton = !userInfo || (userInfo && !userInfo.isAdmin)

  const logoutHandler = () => {
    setOpen(false)
    dispatch(logout())
    history.push('/login')
  }

  const handleDashboardClick = () => {
    setOpen(false)
    history.push('/myquality/dashboard')
  }

  const handleMyAccountClick = () => {
    setOpen(false)
    history.push('/myquality/preferences')
  }

  const handleCreateAQuoteClick = () => {
    setOpen(false)
    history.push('/createaquote')
  }

  const handleLogInClick = () => {
    setOpen(false)
    dispatch({ type: LOGIN_TAB_OPEN })
    history.push('/login')
  }

  const handleSignUpClick = () => {
    setOpen(false)
    dispatch({ type: SIGNUP_TAB_OPEN })
    history.push('/login')
  }

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen)
  }

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return
    }

    setOpen(false)
  }

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault()
      setOpen(false)
    }
  }

  return (
    <>
      {showCreateAQuoteButton && (
        <Button
          className="btn btn-gradient start-a-quote m-r-16 hide-580"
          onClick={handleCreateAQuoteClick}
        >
          Start a quote
        </Button>
      )}

      {!userInfo ? (
        size.width > 767 ? (
          <>
            <Button
              className={`m-r-16 ${isHomePage ? 'white-text' : ''}`}
              color="primary"
              onClick={handleLogInClick}
            >
              Log in
            </Button>
            <Button
              variant="contained"
              className={isHomePage ? 'white-text' : ''}
              color="primary"
              onClick={handleSignUpClick}
            >
              Sign up
            </Button>
          </>
        ) : (
          <Button
            ref={anchorRef}
            aria-controls={open ? 'menu-list-grow' : undefined}
            aria-haspopup="true"
            onClick={handleToggle}
            className={isHomePage ? 'white-text' : ''}
          >
            <span className="name-dot">
              <Person style={{ width: 18 }} />
            </span>
            <ArrowDropDownIcon />
          </Button>
        )
      ) : (
        <Button
          ref={anchorRef}
          aria-controls={open ? 'menu-list-grow' : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
          className={isHomePage ? 'white-text' : ''}
        >
          <span className="name-dot">
            {userInfo.firstName.charAt(0)}
            {userInfo.lastName.charAt(0)}
          </span>
          <span className="full-name">
            {userInfo.firstName} {userInfo.lastName}
          </span>
          <ArrowDropDownIcon />
        </Button>
      )}
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <Paper className="form-container">
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList
                  autoFocusItem={open}
                  id="menu-list-grow"
                  onKeyDown={handleListKeyDown}
                >
                  {!userInfo ? (
                    <div>
                      <MenuItem onClick={handleCreateAQuoteClick}>
                        Start a quote
                      </MenuItem>
                      <MenuItem onClick={handleLogInClick}>Login</MenuItem>
                      <MenuItem onClick={handleSignUpClick}>Sign up</MenuItem>
                    </div>
                  ) : (
                    <div>
                      <MenuItem onClick={handleDashboardClick}>
                        Dashboard
                      </MenuItem>
                      <MenuItem onClick={handleMyAccountClick}>
                        My account
                      </MenuItem>
                      <MenuItem onClick={logoutHandler}>Log out</MenuItem>
                    </div>
                  )}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  )
}

export default NavMenu
